import React from 'react';
import './Footer.css';

const Footer = ({
  onNavigateToHome,
  onNavigateToBrowseRFQs,
  onNavigateToPostRFQ,
  onNavigateToForBusinesses,
  onNavigateToForFreelancers,
  onNavigateToContact,
  onNavigateToAbout
}) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Main Footer */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-column">
            <div className="footer-logo">
              <img 
                src="https://i.ibb.co/jk4rbQ7g/download-logo.png" 
                alt="Global Expedyte Logo" 
                className="footer-logo-image"
              />
              <div className="footer-logo-text">
                <span className="footer-logo-name">GLOBAL EXPEDYTE</span>
                <span className="footer-logo-tagline">RFQ Marketplace</span>
              </div>
            </div>
            <p className="footer-description">
              South Africa's premier RFQ marketplace connecting businesses with 
              verified freelancers across all industries. Post projects, get quotes, 
              hire talent.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* For Businesses */}
          <div className="footer-column">
            <h4>For Businesses</h4>
            <button onClick={onNavigateToPostRFQ}>Post a Brief</button>
            <button onClick={onNavigateToBrowseRFQs}>Browse Freelancers</button>
            <button onClick={onNavigateToForBusinesses}>How It Works</button>
            <button onClick={onNavigateToContact}>Get Started</button>
          </div>

          {/* For Freelancers */}
          <div className="footer-column">
            <h4>For Freelancers</h4>
            <button onClick={onNavigateToBrowseRFQs}>Browse Briefs</button>
            <button onClick={onNavigateToForFreelancers}>How It Works</button>
            <button onClick={onNavigateToContact}>Join as Freelancer</button>
            <button onClick={onNavigateToContact}>Pricing</button>
          </div>

          {/* Company */}
          <div className="footer-column">
            <h4>Company</h4>
            <button onClick={onNavigateToAbout}>About Us</button>
            <button onClick={onNavigateToContact}>Contact Us</button>
            <button onClick={onNavigateToHome}>Blog</button>
            <button onClick={onNavigateToHome}>Careers</button>
          </div>

          {/* Support */}
          <div className="footer-column">
            <h4>Support</h4>
            <button onClick={onNavigateToContact}>Help Center</button>
            <button onClick={onNavigateToHome}>Terms of Service</button>
            <button onClick={onNavigateToHome}>Privacy Policy</button>
            <button onClick={onNavigateToContact}>Report Issue</button>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-legal">
              <p>&copy; {new Date().getFullYear()} Global Expedyte (Pty) Ltd. All rights reserved.</p>
              <p className="footer-reg">Registration: 2022/226634/07 | South Africa</p>
            </div>
            <div className="footer-contact">
              <a href="mailto:info@globalexpedyte.co.za">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                info@globalexpedyte.co.za
              </a>
              <a href="tel:+27XXXXXXXXX">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                </svg>
                +27 (0) 61 626 5828
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;